/**
 * Every "fetch" function should use a lock, otherwise we end up with duplicate API calls (e.g. when switching accounts).
 * This exists to standardize the async locks' options.
 */
export const fetchLockOptions = {timeout: 30000, maxPending: 500};
